import * as React from 'react';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Stack from '@mui/joy/Stack';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';

// Función para convertir texto estilo WhatsApp a HTML
function parseWhatsappMarkdown(text) {
  let html = text;

  // Negrita con _
  html = html.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

  // Cursiva con *
  html = html.replace(/\_(.*?)\_/g, '<em>$1</em>');

  // Tachado con ~
  html = html.replace(/~(.*?)~/g, '<s>$1</s>');

  // Saltos de línea
  html = html.replace(/\n/g, '<br>');

  return html;
}

export default function ChatBubble(props) {
  const { message, variant, creation_time, attachment = undefined, sender, user_profile } = props;
  const isSent = variant === 'sent';
  const parsedMessage = parseWhatsappMarkdown(message);

  return (
    <Box sx={{ maxWidth: '60%', minWidth: 'auto' }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{ justifyContent: 'space-between', mb: 0.25 }}
      >
        <Typography level="body-xs">
          {sender === 'You' ? sender : user_profile}
        </Typography>
        <Typography level="body-xs">{creation_time}</Typography>
      </Stack>

      {attachment ? (
        <Sheet
          variant="outlined"
          sx={[
            {
              px: 1.75,
              py: 1.25,
              borderRadius: 'lg',
            },
            isSent ? { borderTopRightRadius: 0 } : { borderTopRightRadius: 'lg' },
            isSent ? { borderTopLeftRadius: 'lg' } : { borderTopLeftRadius: 0 },
          ]}
        >
          <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center' }}>
            <Avatar color="primary" size="lg">
              <InsertDriveFileRoundedIcon />
            </Avatar>
            <div>
              <Typography sx={{ fontSize: 'sm' }}>{attachment.fileName}</Typography>
              <Typography level="body-sm">{attachment.size}</Typography>
            </div>
          </Stack>
        </Sheet>
      ) : (
        <Box sx={{ position: 'relative' }}>
          <Sheet
            color={isSent ? 'primary' : 'neutral'}
            variant={isSent ? 'solid' : 'soft'}
            sx={[
              {
                p: 1.25,
                borderRadius: 'lg',
              },
              isSent
                ? { borderTopRightRadius: 0 }
                : { borderTopRightRadius: 'lg' },
              isSent
                ? { borderTopLeftRadius: 'lg' }
                : { borderTopLeftRadius: 0 },
              {
                backgroundColor: 'background.body',
              },
            ]}
          >
            <Typography
              level="body-sm"
              textAlign={'left'}
              sx={[
                isSent
                  ? { color: 'var(--joy-palette-common-white)' }
                  : { color: 'var(--joy-palette-text-primary)' },
                {
                  '& span': {
                    color: 'black'
                  }
                }
              ]}
            >
              <span dangerouslySetInnerHTML={{ __html: parsedMessage }} />
            </Typography>
          </Sheet>
        </Box>
      )}
    </Box>
  );
}
